import React from 'react';
import styled from 'styled-components';

const FreshnessBadge = ({ status = 'unknown', sourceType = 'summary' }) => (
    <Badge $status={status} $sourceType={sourceType}>
        {sourceType === 'summary' ? 'Summary' : 'Operational'} · {status}
    </Badge>
);

export default FreshnessBadge;

const statusStyles = (theme, status) => {
    if (status === 'success') return { bg: theme.colors.successBg, color: theme.colors.success };
    if (status === 'failed') return { bg: theme.colors.dangerBg, color: theme.colors.danger };
    if (status === 'running' || status === 'queued') return { bg: theme.colors.infoBg, color: theme.colors.info };
    if (status === 'not_configured') return { bg: theme.colors.surfaceMuted, color: theme.colors.textMuted };
    return { bg: theme.colors.warningBg, color: theme.colors.warning };
};

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 0.25rem 0.625rem;
    font-size: 0.75rem;
    font-weight: 600;
    ${({ theme, $status }) => {
        const styles = statusStyles(theme, $status);
        return `
            background: ${styles.bg || '#f3f4f6'};
            color: ${styles.color || '#6b7280'};
        `;
    }}
`;

